export default ['Marquee', 'Mid-tier', 'Mini-cap'];
